export type { EmojiProps } from './Emoji';
export { Emoji } from './Emoji';
